import React, { useRef, useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';
import Tooltip from '@mui/material/Tooltip';
import PrinterIcon from '@mui/icons-material/PrintTwoTone';
// import PrintPreview from '../../Devices/PrintPreview';

export default function PrintButton(props) {
    const [open, setOpen] = useState(false);
    const anchorRef = useRef(null);
    const { list } = props;

    const handleClose = event => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        };    
        setOpen(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpen(false);
        }
    }

    const handleClick = (index) => {
        if(list != null && list.length > 0) {
            list[index].onClick();
            setOpen(false);
        }        
    }

    const handleToggle = () => {
        setOpen(prevOpen => !prevOpen);
    };

    const multiPrint = (
        <React.Fragment>
            <Tooltip title='Print' placement='top'>
                <IconButton onClick={handleToggle} id="printIcon" aria-haspopup="true" sx={{ borderRadius: '4px', margin: 0, color: 'primary.main', minWidth: 0 }}
                            ref={anchorRef} disableRipple
                            aria-controls={open ? 'menu-list-grow' : undefined}>
                            <PrinterIcon sx={{ borderRadius: '4px' }}/>
                </IconButton>
            </Tooltip>
            <Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
            {({ TransitionProps }) => (
                <Grow
                {...TransitionProps}
                sx={{ transformOrigin: 'center bottom' }}
                >
                <Paper>
                    <ClickAwayListener onClickAway={handleClose}>
                        <MenuList autoFocusItem={open} id="printMenuList" onKeyDown={handleListKeyDown}>
                            {list != null && list.length > 1 && list.map((item, index) => (
                                <MenuItem key={'printBtn-' + index} onClick={() => handleClick(index)} disabled={!item.enabled}>{item.label}</MenuItem>
                            ))}
                        </MenuList>
                    </ClickAwayListener>
                </Paper>
                </Grow>
            )}
            </Popper>
        </React.Fragment>
    );

    const singlePrint = (
        <Tooltip title='Print' placement='top'>
            <IconButton onClick={() => handleClick(0)} id="printIcon" aria-haspopup="true" sx={{ borderRadius: '4px', color: 'primary.main' }}>
                <PrinterIcon />
            </IconButton>
        </Tooltip>
    );

    if(list != null && list.length > 1) {
        return multiPrint;
    }else {
        return singlePrint;
    }
}